module.exports = __webpack_public_path__ + "static/story4-02-533x800-046ef8d8b0a8741fe105f4dbaeccd0d8.jpg";